import { BussinessRegAppService } from './../../service/business-reg-app/bussiness-reg-app.service';
import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { TRCAppForm } from 'app/shared/models/tRCAppForm.model';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { TRCNextSteps } from 'app/shared/models/tRCNextSteps.model';
import { Answer } from 'app/shared/models/Answer.model';


@Component({
  selector: 'jhi-eappreg-criteria',
  templateUrl: './eappreg-criteria.component.html',
  styleUrls: ['./eappreg-criteria.component.scss']
})
export class EappregCriteriaComponent implements OnInit {

  urlExemptionId : any  ;
  eAppRegConstant = BUSINESS_REG_APP_CONSTANT ;
  tRCFuzzyMatches = [] ;
  tRCDataErrors = [] ; 
  tRCQGroups : any ;
  tRCBusQues : any ;
  qBusGrp : any ;
  qMaxLevel : any ;
  tRCStreetTypes : any ;
  tRCUnitTypes : any ;
  tRCBusTypes : any ;
  startWithId = null ;
  legalName :any;
  dBA  :any;
referenceNo  :any;
reason :any;

  
  constructor(private route: ActivatedRoute,
    private titleService : Title,
    private businessRegAppService : BussinessRegAppService 
    ) { 

      this.urlExemptionId = this.route.snapshot.queryParamMap.get('exemption_id') ;
        this.legalName =  this.route.snapshot.queryParamMap.get('Legal');
		this.dBA = this.route.snapshot.queryParamMap.get('DBA');
		this.referenceNo=this.route.snapshot.queryParamMap.get('ReferenceNo');
		this.reason = this.route.snapshot.queryParamMap.get('Reason');
      //Display relevant title based on exemption_id
      if(this.urlExemptionId !== undefined && Number(this.urlExemptionId) === 19){
        this.titleService.setTitle("Vendor Registration") ;
      }else if(this.urlExemptionId !== undefined && this.urlExemptionId >= 13 && this.urlExemptionId <= 16){
        this.titleService.setTitle("Non-Profit Registration") ;
      }else{
        this.titleService.setTitle(this.eAppRegConstant.PageTitle)
      }
    }

  ngOnInit(): void {
    // user came from the right page 
    if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_questionnaire" || sessionStorage.getItem("TRCCurrentPage") === "eappreg_fasttrack"){
      sessionStorage.setItem("TRCCurrentPage","eappreg_criteria") ;
      //OK - user clicked refresh
    }else if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_criteria"){
      // refreshed
    }else{
      //New session - or something went wrong...
      //Make sure get a fresh start... 
      sessionStorage.clear() ;
 	 
      sessionStorage.setItem("TRCCurrentPage","eappreg_criteria") ;

      sessionStorage.setItem("TRCQForms",sessionStorage.getItem("TRCQForms") ?? "[]")

      sessionStorage.setItem("TRCPLCForm",sessionStorage.getItem("TRCPLCForm") ?? "[]")

      sessionStorage.setItem("TRCFREForm",sessionStorage.getItem("TRCFREForm") ?? "[]")

      sessionStorage.setItem("TRCTBCForm",sessionStorage.getItem("TRCTBCForm") ?? "[]")

      const tRCFundClasses:TRCFundClasses[] =[]
      sessionStorage.setItem("TRCFundClasses",JSON.stringify(tRCFundClasses))

      const tRCNextSteps = new TRCNextSteps() ;
      sessionStorage.setItem("TRCNextSteps",JSON.stringify(tRCNextSteps))

      sessionStorage.setItem("TRCFuzzyMatches",JSON.stringify(this.tRCFuzzyMatches))

      sessionStorage.setItem("TRCDataErrors",JSON.stringify(this.tRCDataErrors))

	  const tRCAppForm = new TRCAppForm() ;
	  sessionStorage.setItem("TRCAppForm",JSON.stringify(tRCAppForm)) ;

 	  sessionStorage.setItem("LegalName",this.legalName?this.legalName:"");
      sessionStorage.setItem("DBAName",this.dBA?this.dBA:"");

 	  sessionStorage.setItem("ReferenceNo",this.referenceNo?this.referenceNo:"");
      sessionStorage.setItem("Reason",this.reason?this.reason:"");

      if(this.urlExemptionId !== undefined){
       tRCAppForm.exemption_Id = this.urlExemptionId
      }
    
      sessionStorage.setItem("TRCLogPath","/opt/coldfusion11/cfusion/logs/")

      this.businessRegAppService.getQuestionGroups()
      .subscribe((res : any)=>{
        this.tRCQGroups = res ;
        sessionStorage.setItem("TRCQGroups",JSON.stringify(this.tRCQGroups))
      },()=>{/*empt*/ },
      ()=>{
        this.businessRegAppService.getQuestionGrpId(this.eAppRegConstant.Meta_name).subscribe((res1: any)=>{
          this.qBusGrp = res1 ;
          sessionStorage.setItem("TRCBusGrpId",this.qBusGrp)
        },() =>{/*empty*/},()=>{
          this.businessRegAppService.getQuestionHierarchyWithId(sessionStorage.getItem("TRCBusGrpId") ?? "").subscribe((res : any)=>{
            this.tRCBusQues = res ;
            sessionStorage.setItem("TRCBusQues",JSON.stringify(this.tRCBusQues))
            this.businessRegAppService.getTRCMaxLevel(sessionStorage.getItem("TRCBusGrpId") ?? "").subscribe((res1 : any)=>{
              this.qMaxLevel = res1 ;
              sessionStorage.setItem("TRCMaxLevel",this.qMaxLevel)
              sessionStorage.setItem("TRCAlphaList","a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z")
              this.businessRegAppService.getStreetType().subscribe((res2 : any)=>{
                this.tRCStreetTypes = res2 ;
              sessionStorage.setItem("TRCStreetTypes",JSON.stringify(this.tRCStreetTypes)) ;
              })
        this.businessRegAppService.getStates().subscribe(( stateListRes : any)=>{
              sessionStorage.setItem("stateList",JSON.stringify(stateListRes));
              })
              this.businessRegAppService.getUnitType().subscribe((res3 : any)=>{
                this.tRCUnitTypes = res3 ;
              sessionStorage.setItem("TRCUnitTypes",JSON.stringify(this.tRCUnitTypes));
              })
              this.businessRegAppService.getMiscTypeBusiness().subscribe((res4 : any)=>{
                this.tRCBusTypes = res4 ;
              sessionStorage.setItem("TRCBusTypes",JSON.stringify(this.tRCBusTypes)) ;
              sessionStorage.setItem("TRCQuesPgCnt","0");
              sessionStorage.setItem("TRCQuesActPgCnt","0");
              sessionStorage.setItem("TRCLogKey","") ;
              })
            }) 
          })
        })
      
      }) 
  }

  }

  print_page() : void {
    window.print() ;
  }


    
}
